import { render, staticRenderFns } from "./member-order-phone.component.vue?vue&type=template&id=0125a66f"
import script from "./member-order-phone.component.vue?vue&type=script&lang=js"
export * from "./member-order-phone.component.vue?vue&type=script&lang=js"
import style0 from "./member-order-phone.component.vue?vue&type=style&index=0&id=0125a66f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports